export default {
  activityReportTitle: 'Activity Report',
  teamPointsReportTitle: 'Team Points Report',
  teamPointsByActivityReportTitle: 'Team Points by Activity Report',
  monthlyTotalReportTitle: 'Monthly Total Report',
  export: 'Generate Report',
  backToAttorneyReports: 'Back to Attorney Reports',
  filters: {
    completedAt: 'Completed at',
    createdAt: 'Created At',
    date: 'Date',
    activityType: 'Activity Type',
    team: 'Team',
  },
};
